import React, { useEffect, useState } from "react";
import { Typography, Grid, Button, Divider, CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { history } from "../../../../helpers";
import { routePaths } from "../../../config/route-paths";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
import moment from "moment";
import { newConnectionService } from "../model/e_service";
import GetAppIcon from "@material-ui/icons/GetApp";

const useStyles = makeStyles((theme) =>
  createStyles({
    mb0: {
      marginBottom: "0 !important",
    },
    ticketRef: {
      marginTop: "1rem !important",
    },
    ticketNumber: {
      margin: "0 !important",
    },
    gridContentAlign: {
      textAlign: "center",
      margin: "0.4rem 0",
    },
    infoContent: {
      margin: "1rem 0",
    },
    lineHeight: {
      lineHeight: "1.2",
    },
    buttonGrid: {
      textAlign: "right",
      margin: "0.4rem 0",
    },
    headerHr: {
      width: "100%",
      backgroundColor: theme.palette.eLight.base,
    },
    checkCircleIcon: {
      width: "6rem",
      marginTop: "1rem",
      marginBottom: "1rem",
    },
    blueColor: {
      color: theme.palette.ePrimary.base,
    },
    greyColor: {
      color: theme.palette.eRich.base,
    },
    linkColor: {
      color: theme.palette.ePrimary.base,
      textDecoration: "underline",
    },
    buttonInside:{
      backgroundColor:theme.palette.ePrimary?.base,
        color:theme.palette.eWhite?.base,
        ['@media (max-width:600px)']: {
        marginTop:"4px !important",
        fontSize:"0.8rem"
        },
        borderRadius: "3rem",
        "&:hover": {
          backgroundColor: theme.palette.ePrimary?.hover
      }
    },
    alignButtonCenter:{
        display: "flex",
        justifyContent: "space-around",
        textAlign: "center",
      marginTop:"1rem",
      marginBottom:"1rem"
    },
    okButton: {
      padding: "0.6% 4%",
      color: theme.palette.eWhite.base,
      backgroundColor: theme.palette.ePrimary.base,
      borderRadius: "2rem",
      "&:hover": {
        backgroundColor: theme.palette.ePrimary.hover,
      },
    },
    lastHR: {
      marginTop: "5%",
    },
    whiteColor: {
      color: theme.palette.eWhite?.base,
    },
  })
);

export default function Content({ ticketNo, content, checkCircle, downloadIcon,
  name,
  districtPremise,
  address1Premise,
  address2Premise,
  postOfficePremise,
  divisionPremise,
  postCodePremise,
  thanaPremise,
  mobile,
  connectionType,
  meterType,
  Load,
  tarrifType,
  applicationDate }) {
  let classes = useStyles();
  const { t: labels, ready: labelReady } = useTranslation("label-E_CONFIRMATION_SCREEN");
  const [spinner,setspinner]=useState(false)
  let supportEmail = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.CUSTOMER_HELP_EMAIL_ADDRESS
  );

  const okHandler = () => {
    history.push(routePaths.LOGIN);
  };
  let languageCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const downloadHandler = () => {
    setspinner(true)
    newConnectionService
      .getPDF({languageCode,ticketNo
      })
      .then((res) => {
        saveAs('data:application/pdf;base64,'+res.data.getBase64DocumentAuthClient, getFileName());
        setspinner(false)
      }).catch((e)=>{
        setspinner(false)
      });
  };
  const getFileName = () => {
    let fileName = ticketNo;
    if(labelReady) {
      fileName = fileName + labels("E_CONFIRMATION_PDF_FILENAME")
    }
    return fileName;
}
  return (
    <Grid container alignItems="center" justify="center">
      <Grid item xs={12} className={classes.gridContentAlign}>
        {checkCircle ? (
          <img
            src={checkCircle.assetPath}
            className={classes.checkCircleIcon}
            alt={labelReady ? labels("E_CONFIRMATION_CHECK_CIRCLE_FALLBACK") : ''}
          ></img>
        ) : (
          <Skeleton />
        )}
      </Grid>
      <Grid item xs={12} className={[classes.gridContentAlign, classes.mb0]}>
      {
        labelReady ?
        <Typography variant="h5" className={classes.blueColor}>
          <b> {labels("E_CONFIRMATION_THANK_YOU")}</b>
        </Typography>
        : <Skeleton />
      }
      </Grid>
      <Grid item xs={12} className={classes.gridContentAlign}>
      {
        labelReady ?
        <Typography variant="subtitle2" className={classes.greyColor}>
          {labels("E_CONFIRMATION_REQUEST_RECEIVED")}
        </Typography>
        : <Skeleton />
      }
      </Grid>
      <Grid item xs={12} md={8} lg={6} className={classes.gridContentAlign}>
        <Divider className={classes.headerHr}></Divider>
      </Grid>
      <Grid item xs={12} className={[classes.mb0, classes.gridContentAlign, classes.ticketRef]}>
      {
        labelReady ?
        <Typography
          variant="h6"
          className={[classes.greyColor, classes.lineHeight]}
        >
         {ticketNo.includes(",")?labels("E_CONFIRMATION_MULTIPLE_TICKET_REF_NO"):labels("E_CONFIRMATION_TICKET_REF_NO")}
        </Typography>
        : <Skeleton />
      }
      </Grid>
      <Grid
        item
        xs={12}
        className={[classes.ticketNumber, classes.gridContentAlign]}
      >
        <Typography
          variant="h6"
          className={[classes.blueColor, classes.lineHeight]}
        >
          <b>{ticketNo}</b>
        </Typography>
      </Grid>
      <Grid xs={12} className={classes.alignButtonCenter}>
         <Button
            variant="contained"
            className={classes.buttonInside}
            onClick={downloadHandler}
            endIcon={<><GetAppIcon fontSize="small" />{spinner ? (
              <CircularProgress
                size={19}
                className={classes.whiteColor}
              />
            ) : null}</>}
          >
            <Typography>{labelReady ? labels("E_DOWNLOAD_SUMMARY"):<Skeleton/>} </Typography>
        </Button>
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
        lg={6}
        className={[classes.infoContent, classes.gridContentAlign]}
      >
        {content ? (
          <Typography variant="subtitle2" className={classes.greyColor}>
            {content("E_CONFIRMATION_INFO").answer}
          </Typography>
        ) : (
          <Skeleton />
        )}
      </Grid>
      <Grid item xs={12} className={classes.gridContentAlign}>
      {
        labelReady ?
        <Link
          underline="always"
          className={classes.linkColor}
          to={{ pathname: routePaths.LOGIN, state: { tab: "FAQ" } }}
        >
          <b>{labels("E_CONFIRMATION_FAQS")}</b>
        </Link>
        : <Skeleton />
      }
      </Grid>
      <Grid item xs={12} md={8} lg={6} className={classes.gridContentAlign}>
        <Divider className={classes.headerHr}></Divider>
      </Grid>
      <Grid item xs={12} className={classes.gridContentAlign}>
      {
        labelReady ?
        <Typography variant="subtitle2" className={classes.greyColor}>
          {labels("E_CONFIRMATION_FOR_INQUIRIES")}
          <a href={"mailto:" + supportEmail} className={classes.linkColor}>
            {supportEmail}
          </a>
        </Typography>
        : <Skeleton />
      }
      </Grid>
      <Grid item xs={12} className={[classes.gridContentAlign, classes.lastHR]}>
        <Divider className={classes.headerHr}></Divider>
      </Grid>
      <Grid item xs={12} className={classes.buttonGrid}>
        <Button
          variant="contained"
          className={classes.okButton}
          onClick={okHandler}
        >
          {labelReady ? labels("E_CONFIRMATION_OK") : <Skeleton />}
        </Button>
      </Grid>
    </Grid>
  );
}
